var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading-dialog',{attrs:{"show":"","text":"Stiamo verificando la tua mail..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }